import React from 'react';

import Button from '@pb/kit-component-button';
import {Dialog, DialogFooter, DialogHeader} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {Message} from '@pb/kit-component-message';
import Typography from '@pb/kit-component-typography';

import {useAddVendorUserDialog} from '../../hooks/use-add-vendor-user-dialog';

import {AddVendorUserForm} from './add-vendor-user-form';

type Props = {
    showDialog: boolean,
    closeDialog: () => void,
    vendorId?: string,
    onUserAdded?: () => void,
};

export const AddVendorUserDialog: React.FC<Props> = ({showDialog, closeDialog, vendorId, onUserAdded}) => {
    const {
        form,
        emailInput,
        shown,
        hasSearched,
        searchLoading,
        suggestUsers,
        userLookupLoading,
        isInviteDisabled,
        displayError,
        isMinQueryShown,
        busy,
        handleEmailChange,
        handleUserSelect,
        clearSuggest,
        setShown,
        handleInviteClick,
        handleClose,
    } = useAddVendorUserDialog({vendorId, closeDialog, onUserAdded});

    return (
        <Dialog
            shown={showDialog}
            setShown={visible => {
                if (!visible) {
                    handleClose();
                }
            }}>
            <DialogHeader onClose={handleClose}>
                <Typography variant="heading-level-2">
                    Add User
                </Typography>
            </DialogHeader>
            <Group direction="v" style={{padding: 24, width: 400}}>
                {displayError ? (
                    <Message color="error" style={{paddingBottom: 12}}>
                        {displayError}
                    </Message>
                ) : null}
                <AddVendorUserForm
                    emailInput={emailInput}
                    firstName={form.firstName}
                    lastName={form.lastName}
                    suggestUsers={suggestUsers}
                    searchLoading={searchLoading}
                    hasSearched={hasSearched}
                    isMinQueryShown={isMinQueryShown}
                    shown={shown}
                    onEmailChange={handleEmailChange}
                    onUserSelect={handleUserSelect}
                    onClearSuggest={clearSuggest}
                    onSetShown={setShown}
                    onBlur={() => setShown(false)}
                />
            </Group>
            <DialogFooter>
                <Button
                    variant="Type.PRIMARY"
                    disabled={isInviteDisabled}
                    busy={busy || searchLoading || userLookupLoading}
                    onClick={handleInviteClick}>
                    Add
                </Button>
                <Button onClick={handleClose} busy={busy} variant="Type.SECONDARY">
                    Cancel
                </Button>
            </DialogFooter>
        </Dialog>
    );
};
